import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  MatNativeDateModule,
  NativeDateModule
} from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

import { MY_NATIVE_DATE_FORMATS } from '@amfam/billing/one-time-pay/feature';
import { BillingSharedUiModule } from '@amfam/billing/shared/ui';
import { PipesModule } from '@amfam/shared/ui/pipes';
import { SharedServicesModule } from '@amfam/shared/utility/shared-services';
import { UiKitModule } from '@amfam/ui-kit';

import { AccountDescriptionMinimalComponent } from './account-description-minimal/account-description-minimal.component';
import { AccountListComponent } from './account-list/account-list.component';
import { ChoosePaymentAmountComponent } from './choose-payment-amount/choose-payment-amount.component';
import { OneTimePayReviewItemComponent } from './one-time-pay-review-item/one-time-pay-review-item.component';
import { SelectPaymentDateComponent } from './select-payment-date/select-payment-date.component';
import { SimplifiedPaymentCheckboxComponent } from './simplified-payment-checkbox/simplified-payment-checkbox.component';
import { TotalAmountComponent } from './total-amount/total-amount.component';

@NgModule({
  declarations: [
    TotalAmountComponent,
    SelectPaymentDateComponent,
    AccountListComponent,
    OneTimePayReviewItemComponent,
    ChoosePaymentAmountComponent,
    AccountDescriptionMinimalComponent,
    SimplifiedPaymentCheckboxComponent
  ],
  exports: [
    TotalAmountComponent,
    SelectPaymentDateComponent,
    AccountListComponent,
    OneTimePayReviewItemComponent,
    ChoosePaymentAmountComponent,
    AccountDescriptionMinimalComponent,
    SimplifiedPaymentCheckboxComponent
  ],
  imports: [
    CommonModule,
    UiKitModule,
    PipesModule,
    BillingSharedUiModule,
    MatFormFieldModule,
    MatInputModule,
    MatNativeDateModule,
    MatDatepickerModule,
    NativeDateModule,
    SharedServicesModule
  ],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_NATIVE_DATE_FORMATS }
  ]
})
export class BillingOneTimePayUiModule {}
